module.exports = __webpack_public_path__ + "img/meeting-room-1.b5d552da.jpg";